import React, { useState, useEffect } from "react";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Navbar from "./components/Navbar";
import AccessGuard from "./components/AccessGuard";
import "./styles/global.css";
import Tasks from "./pages/Tasks";


function App() {
    const [activePage, setActivePage] = useState("home");
    const [darkMode, setDarkMode] = useState(true);

    useEffect(() => {
        // Zapamiętaj preferencję użytkownika
        const saved = localStorage.getItem("wesele_theme");
        if (saved) {
            setDarkMode(saved === "dark");
        }
    }, []);

    useEffect(() => {
        // Zastosuj tryb na całej stronie
        document.documentElement.setAttribute(
            "data-theme",
            darkMode ? "dark" : "light"
        );
        localStorage.setItem("wesele_theme", darkMode ? "dark" : "light");
    }, [darkMode]);
    const [installPrompt, setInstallPrompt] = useState(null);
    const [showInstallBanner, setShowInstallBanner] = useState(false);

    useEffect(() => {
        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            setInstallPrompt(e);
            setShowInstallBanner(true);
        });
    }, []);

    const handleInstall = () => {
        if (installPrompt) {
            installPrompt.prompt();
            installPrompt.userChoice.then((result) => {
                if (result.outcome === "accepted") {
                    setShowInstallBanner(false);
                }
            });
        }
    };
    return (
        <AccessGuard>
            {showInstallBanner && (
                <div className="install-banner">
                    <span className="install-banner-icon">📱</span>
                    <span className="install-banner-text">
      Dodaj stronę do ekranu głównego!
    </span>
                    <button className="install-banner-btn" onClick={handleInstall}>
                        Zainstaluj
                    </button>
                    <button
                        className="install-banner-close"
                        onClick={() => setShowInstallBanner(false)}
                    >
                        ✕
                    </button>
                </div>
            )}
            <div className="app">
                <Navbar
                    activePage={activePage}
                    setActivePage={setActivePage}
                    darkMode={darkMode}
                    setDarkMode={setDarkMode}
                />
                {activePage === "home" && <Home setActivePage={setActivePage} />}
                {activePage === "gallery" && <Gallery />}
                {activePage === "tasks" && <Tasks />}
            </div>

        </AccessGuard>
    );
}

export default App;